export default __webpack_public_path__ + "static/media/AktivGrotesk-Regular.d05b19c2.ttf";